export default __webpack_public_path__ + "db4a01cb91bccfe373b33425f7b4b105.png";